module.exports = __webpack_public_path__ + "static/img/18.817c472.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue13/YearsOfInnocence/18.jpg
// module id = gPmA
// module chunks = 7